import React from "react";
import {StyledMyBackButton} from "./MyBackButton.styles";
import {AdaptiveGoBack} from "../../../assets";
import {Row} from "antd";
import {useNavigate} from "react-router-dom";

export const MyBackButton = ({children, ...props}) => {
    const navigate = useNavigate();
    return (
      <StyledMyBackButton onClick={() => navigate("/")} className="backButton" {...props}>
          <Row>
              <AdaptiveGoBack className="icon"/>
              <span className="text">Go Back</span>
          </Row>
      </StyledMyBackButton>
    )
}